import { useEffect, useState } from 'react';
/**
 * @deprecated use marketplace-ui-common
 */

export const useDebounceValue = (value, delayMs = 250) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(handler);
  }, [delayMs, value]);
  return debouncedValue;
};